import Modal from '../../../../components/Modal'
import * as verifySuccess from '../../../../assets/animations/verify-success.json'
import Lottie from 'react-lottie'
import Text from '../../../../components/Text'
import { useEffect, useState } from 'react'
import ProceedButton from '../../../../components/Signup/ProceedButton'

const VerifySuccess = ({ onClose, isOpen = false, planExtension = false }) => {
  const [timeLeft, setTimeLeft] = useState(5)

  const messages = {
    newPlan: {
      title: 'Your Zy-verify code has been successfully verified',
      description:
        'Thank you for confirming your Viemax pack, you’re all set to continue.',
    },
    updatePlan: {
      title: 'Your program has been extended!',
      description:
        'Congratulations! Your Viemax Care Program has been successfully extended. You can now continue enjoying all your program benefits.',
    },
  }

  const alertLoaderOption = {
    loop: true,
    autoplay: true,
    animationData: verifySuccess,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    let timer
    if (isOpen) {
      setTimeLeft(5) // Reset timer when modal opens

      // Timer for countdown
      const countdownInterval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(countdownInterval)
          }
          return prevTime - 1
        })
      }, 1000)

      // Timer for closing modal
      timer = setTimeout(() => {
        // onClose(true)
      }, 5000)

      return () => {
        clearTimeout(timer)
        clearInterval(countdownInterval)
      }
    }
  }, [isOpen])
  return (
    <Modal isOpen={isOpen} fullScreen showCloseBtn={false} onClose={onClose}>
      <div className="h-[90vh] flex flex-col justify-center items-center">
        <div>
          <Lottie
            options={alertLoaderOption}
            height={120}
            width={120}
            className="mx-auto"
          />
        </div>
        <div className="space-y-4 px-4">
          <Text
            tag="h1"
            variant="headline"
            size="medium"
            textalign="center"
            className="text-[#1F2933]"
          >
            {messages[planExtension ? 'updatePlan' : 'newPlan'].title}
          </Text>
          <Text
            tag="p"
            variant="body"
            size="medium"
            textalign="center"
            className="text-[#5A6774]"
          >
            {messages[planExtension ? 'updatePlan' : 'newPlan'].description}
          </Text>
        </div>
        <ProceedButton onMoveNext={onClose} />
      </div>
    </Modal>
  )
}

export default VerifySuccess
